<template>
    <el-card>
        <div slot="header" class="clearfix">
            <span>邮件内容编辑器</span>
        </div>

        <el-card v-if="showTemplate === true">
            <div slot="header" class="clearfix">
                <span>模板选择：</span>
            </div>

            <el-select v-model="templateName" filterable @change="templateChange">
                <el-option v-for="item in templateOptions" :key="item.id" :value="item.id" :label="item.templateName" v-if="templateType == 'common'">
                </el-option>
                <el-option v-for="item in templateOptions2" :key="item.id" :value="item.id" :label="item.templateName" v-if="templateType == 'kefu'">
                </el-option>
            </el-select>
        </el-card>

        <el-tabs v-model="editableTabsValue" type="card">
            <el-tab-pane
                v-for="(item2, index2) in langType"
                :key="item2.id"
                :label="item2.label"
                :name="item2.val"
            >
                <span slot="label">{{item2.label}}<el-badge :value="(value.title == '' || value.sender == '' || value.content == '') ? '!' : ''" v-for="(value, key) in mailContentObj" :key="key" v-if ="item2.val == key" class="mail-badge"></el-badge></span>

                <template v-for="(value, key) in mailContentObj" v-if ="item2.val == key">
                    <el-card>
                        <el-form label-position="left" label-width="60px">
                            <el-form-item label='标题'>
                                <el-input v-model="value.title" placeholder="请输入标题"></el-input>
                            </el-form-item>
                            <el-form-item label='发件人'>
                                <el-input v-model="value.sender" placeholder="请输入发件人"></el-input>
                            </el-form-item>

                            <el-form-item label='内容'>
                                <!--<el-input v-model="value.content" type="textarea" :rows="3" placeholder="请输入内容">-->
                                <!--</el-input>-->
                                <quill-editor class="editor-quill" ref="mySendQuillEditor" v-model="value.contentHtml" @change="onEditorChange($event,key)" :options="editorOption"/>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </template>
            </el-tab-pane>
        </el-tabs>

        <el-card v-if="templateType == 'common'">
            <div slot="header" class="clearfix">
                <span>子奖励</span>
                <el-button-group>
                    <el-button @click="addReward()">添加子奖励</el-button>
                    <el-button type="danger" @click="deleteReward()">删除子奖励</el-button>
                </el-button-group>
            </div>
            <template v-for="(rd, rdIdx) in rewardGroups[currentRewardGroupIdx]">
                <el-button :key="rdIdx"
                           :class="{ 'el-button--success': rdIdx === currentRewardIdx }"
                           size="mini" @click="selectReward(rdIdx)" plain>{{ rdIdx + 1 }}
                </el-button>
            </template>
        </el-card>

        <el-card>
            <div slot="header" class="clearfix">
                <span>奖励串详情</span>
            </div>
            <div v-if="currentRewardGroupIdx!==null&&currentRewardIdx!==null">
                <div v-for="(item,index) in rewardGroups[currentRewardGroupIdx]" style="margin-bottom: 20px;">
                    {{item.length!==0?((index+1)+ ': ' + item):''}}
                    <span>{{item.length!==0?('('+ finalContentCNArr[index]+ ')'):''}}</span>
                </div>
            </div>
        </el-card>

        <CommonEditor ref="commonEd" :mailTemplateRewards="mailTemplateRewards" :currentReward="currentReward" :currentRewardIdx="currentRewardIdx" @reward="getReward"  v-if="templateType == 'common'"></CommonEditor>
    </el-card>
</template>

<script>
    import lang_config from '../data/lang_config.json';
    import actionConfirm from '../mixins/action_confirm'
    import mailTemplateApi from "../service/mail_template_api";
    import CommonEditor from "./common_editor";
    import {
        mapState
    } from 'vuex';
    import Utils from '../lib/utils'

    export default {
        name: "mail_editor",
        data() {
            return {
                langSelected: [],
                langOptions: lang_config,
                mailContents: [],
                mailContentObj: {
                    'zh-Hans': {title: "", sender: "", content: [], contentHtml: ""},
                    'zh-Hant': {title: "", sender: "", content: [], contentHtml: ""},
                    'ja-JP': {title: "", sender: "", content: [], contentHtml: ""},
                    'ko-KR': {title: "", sender: "", content: [], contentHtml: ""},
                    'ru-RU': {title: "", sender: "", content: [], contentHtml: ""},
                    'en-US': {title: "", sender: "", content: [], contentHtml: ""}
                },

                // 邮件模板列表
                templateName: '',
                templateData: [],
                templateOptions: [],
                templateOptions2: [],
                templateSingle: [],
                templateDouble: [],

                rewardsStr: '',
                mailTemplateRewards: '',

                editableTabsValue: '',
                globalConfigYunwei: Global_Config_Yunwei,

                rewardGroups: [],
                currentRewardGroupIdx: null,
                currentRewardIdx: null,
                currentReward: null,
                finalContentCNArr:[],


                optionValue: '0',
                options: [
                    {
                        value: '0',
                        label: '必要资源'
                    },
                    {
                        value: '1',
                        label: '怪兽'
                    },
                    {
                        value: '2',
                        label: '怪兽碎片'
                    },
                    {
                        value: '3',
                        label: '材料/道具'
                    },
                    {
                        value: '4',
                        label: '元核'
                    },
                    {
                        value: '6',
                        label: '觉醒结晶'
                    },
                    {
                        value: '7',
                        label: '战纹'
                    },
                    {
                        value: '8',
                        label: '觉醒结晶碎片'
                    },
                    {
                        value: '9',
                        label: '部落公共资源'
                    },
                    {
                        value: '10',
                        label: '回复类道具'
                    },
                    {
                        value: '11',
                        label: '头像'
                    },
                    {
                        value: '12',
                        label: '头像框'
                    },
                    {
                        value: '13',
                        label: '宝箱'
                    },
                    {
                        value: '14',
                        label: '皮肤'
                    },
                    {
                        value: '15',
                        label: '时效类道具'
                    } ,
                    {
                        value: '17',
                        label: '起源盘'
                    },
                    {
                        value: '19',
                        label: '进化光谱'
                    },
                    {
                        value: '20',
                        label: '聊天框'
                    } ,
                    {
                        value: '21',
                        label: '战斗框'
                    } ,
                    {
                        value: '22',
                        label: '元核碎片'
                    }

                ],
                optionMap:{
                    '0':'必要资源',
                    '1':'怪兽',
                    '2':'怪兽碎片',
                    '3':'材料/道具',
                    '4':'元核',
                    '5':'约束性道具',
                    '6':'觉醒结晶',
                    '7':'战纹',
                    '8':'觉醒结晶碎片',
                    '9':'部落公共资源',
                    '10':'回复类道具',
                    '11':'头像',
                    '12':'头像框',
                    '13':'宝箱',
                    '14':'皮肤',
                    '15':'时效类道具',
                    '16':'部落头像',
                    '17':'起源盘',
                    '18':'自选元核',
                    '19':'进化光谱',
                    '20':'聊天框',
                    '21':'战斗框',
                    '22':'元核碎片',
                    '23':'元核髓',
                },
                count1: '',
                count2: '',
                rateSwitch: false,
                isDetail: false,
                countSwitch: false,
                rate: 0.1,
                conditionValue: '',
                value: '',
                alertSwitch:0,
                confirmFinal: false,
                mainReward: {},

                finalCount: '',

                emblemEntryConfigs: [],
                emblemLevel: 1,
                emblemStage: 0,
                emblemQuality: 1,
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                emblemMainProperty: 1,
                emblemFateProperty: 51,
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ],

                editorOption: {
                    modules: {
                        toolbar: {
                            container: [
                                ['bold', 'underline'], // 加粗 斜体 下划线 删除线
                                [{ color: ["#ffffff", "#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466", '#ffc437', '#a6bddd'] }], // 字体颜色、字体背景颜色
                                ['link'] // 链接,图片,视频
                            ],
                            handlers: {
                                image: function(value) {
                                    if (value) {
                                        document.querySelector('#upload').click()  // 劫持原来的图片点击按钮事件
                                    } else {
                                        this.quill.format('image', false)
                                    }
                                }
                            }
                        }
                    }
                },
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken
            }),
        },
        mixins: [actionConfirm],
        mounted() {
            this.getLangs();
            if (this.mailTemplateContent !== undefined && this.mailTemplateContent !== '') {
                this.mailContentObj = this.mailTemplateContent;
            }

            this.addRewardGroup();
            this.rewardContentCN();

            this.queryTemplates();

            setTimeout(() => {
                let langInCookie = Utils.getCookie('lang');
                this.$i18n.locale = langInCookie;
                this.langType.forEach(conf => {
                    if (conf.value == langInCookie) {
                        this.editableTabsValue = conf.val;
                    }
                });
            },3000)

        },
        props: ['mailType', 'mailTemplateContent', 'showTemplate', 'confirmSendMail','mailTemplateRewardStr','templateType'],
        watch: {
            mailTemplateContent(n, l) {
                if (this.mailTemplateContent !== undefined && this.mailTemplateContent !== '') {
                    this.mailContentObj = this.mailTemplateContent;
                }
            },

            confirmSendMail() {
                if (this.confirmSendMail) {
                    this.setMailContent();
                    if (!this.showTemplate) {
                        this.rewardsStr = '';
                        this.finalContentCNArr = [];
                        this.currentRewardGroupIdx= 0;
                        this.currentRewardIdx= 0;
                        this.rewardGroups[this.currentRewardGroupIdx] = [];
                    }
                }
            },

            mailTemplateRewards() {
                this.rewardContentCN();
            },

            mailTemplateRewardStr() {
                this.rewardContentCN();
            }
        },
        methods: {
            setMailContent() {
                this.$emit('mailContent', this.mailContentObj ? this.mailContentObj : this.mailTemplateContent);
                // this.$emit('mailContent', this.mailContents ? this.mailContents : this.mailTemplateContent)

                // this.$emit('rewardsStr', this.rewardsStr ? this.rewardsStr : this.mailTemplateRewards)
                // this.$emit('rewardsStr', this.rewardsStr ? this.rewardsStr : this.mailTemplateRewardStr)
                if (this.showTemplate) {
                    this.$emit('rewardsStr', this.rewardsStr ? this.rewardsStr : this.mailTemplateRewards);
                } else {
                    this.$emit('rewardsStr', this.rewardsStr ? this.rewardsStr : this.mailTemplateRewardStr);
                }
            },

            // 奖励串详情
            rewardContentCN() {
                var data = this.mailTemplateRewards?this.mailTemplateRewards:this.mailTemplateRewardStr;
                if (data == undefined || data == null) return;
                var arr = [];
                data = data.split(';');

                data.forEach(item => {
                    arr.push(item.split(','))
                })
                this.rewardGroups = arr;
                this.currentRewardGroupIdx = 0;
                this.currentRewardIdx = 0;
                this.currentReward = this.rewardGroups[this.currentRewardGroupIdx][this.currentRewardIdx];

                this.rewardGroups[this.currentRewardGroupIdx].forEach((item,index) => {
                    this.resolveRewardStr(item);

                    let optionValueCN = this.optionMap[this.optionValue];
                    let idCn = this.getIdCn(this.optionValue,this.value);
                    let finalCount = '';
                    if (this.countSwitch) {
                        finalCount = this.count1 + "-" + this.count2;
                    } else {
                        finalCount = this.count1
                    }
                    let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                    this.finalContentCNArr[index] = finalContentCN;
                })
            },
            handleLangGroup() {
                let sourceMap = {};
                if (this.mailContents.length < this.langSelected.length) {
                    this.mailContents.forEach(sourceItem => {
                        sourceMap[sourceItem.id] = sourceItem;
                    })

                    this.langSelected.forEach(tarItem => {
                        let item = sourceMap[tarItem.id];
                        if (item === undefined) {
                            this.mailContents.push({
                                id: tarItem.id,
                                val: tarItem.val,
                                title: '',
                                sender: '',
                                content: '',
                                lang: tarItem.lang
                            })
                        }
                    })
                } else {
                    this.langSelected.forEach(sourceItem => {
                        sourceMap[sourceItem.id] = sourceItem;
                    })

                    let arr = [];
                    this.mailContents.forEach(tarItem => {
                        let item = sourceMap[tarItem.id];
                        if (item !== undefined) {
                            arr.push(tarItem);
                        }
                    })
                    this.mailContents = arr;
                }

            },
            templateChange(id) {
                this.templateData.forEach(item => {
                    if (item.id === id) {
                        this.mailContentObj = JSON.parse(item.contentJson);
                        this.mailTemplateRewards = item.rewards;
                    }
                })
            },
            // 邮件模板列表
            queryTemplates() {
                let self = this;
                self.templateOptions = [];
                self.templateOptions2 = [];
                mailTemplateApi.findByName({
                    queryForm: {
                        queryContent: ''
                    },
                    token: self.token
                }).then(res => {
                    self.templateData = res;
                    // self.templateOptions = res;
                    res.forEach(item => {
                        if (item.templateType == 'common') {
                            self.templateOptions.push(item);
                        } else if (item.templateType == 'kefu') {
                            self.templateOptions2.push(item);
                        }
                    })
                })
            },

            addRewardGroup() {
                let rewardGroups = this.rewardGroups;
                rewardGroups.push([]);
                this.currentRewardGroupIdx = rewardGroups.length - 1;
                this.addReward();
            },

            selectReward(idx) {
                this.currentRewardIdx = idx;
                this.currentReward = this.rewardGroups[this.currentRewardGroupIdx][idx];
            },

            addReward() {
                let rewards = this.rewardGroups[this.currentRewardGroupIdx];
                rewards.push([]);
                this.selectReward(rewards.length - 1);
            },

            deleteReward() {
                let rewards = this.rewardGroups[this.currentRewardGroupIdx];
                let len = rewards.length;
                if (len > 0) {
                    let idx = this.currentRewardIdx;
                    rewards.splice(idx, 1);
                    this.finalContentCNArr.splice(idx, 1);
                    this.selectReward(idx >= len - 1 ? len - 2 : idx);
                }

                setTimeout(() => {
                    this.$refs.commonEd.generateReward();
                },1000)
            },

            getReward(mainReward, idx, finalContentCN) {
                this.currentRewardIdx = idx;
                this.rewardGroups[this.currentRewardGroupIdx][idx] = mainReward;
                this.currentReward = this.rewardGroups[this.currentRewardGroupIdx][idx];

                this.finalContentCNArr[idx] = finalContentCN;

                this.rewardsStr = this.rewardGroups[0].join(',');
            },

            resolveRewardStr(str){
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;

                    self.editEmblemEntries = [
                        {
                            entry:[3, 0],
                            quality:0,
                            active:true
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            let bigTypeArry = element.split("$");
                            //大类
                            self.optionValue = bigTypeArry[0];
                            //identify
                            self.value = parseInt(bigTypeArry[1]);
                            if (self.value == 50001) {
                                self.emblemRandomByQuality = false;
                            } else {
                                self.emblemRandomByQuality = true;
                            }
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if(countArry.length>1){
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            }else{
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            //等级
                            self.emblemLevel = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveQuality = parseInt(element);
                            }else if(self.optionValue === '17'){
                                let skillArray = element.split("#");
                                if(skillArray.length>=1 && skillArray[0].split("@").length>1){
                                    self.plateConfigOption1 = 2;
                                    for (let i = 0; i < skillArray.length; i++) {
                                        let item = skillArray[i].split("@");
                                        for(let j=0;j<self.plateConfigs.length;j++){
                                            if(self.plateConfigs[j].id===parseInt(item[0])){
                                                self.plateCustomizeTags1[i] = {id:item[0],chance:item[1],data:self.plateConfigs[j]}
                                            }
                                        }
                                    }

                                }else{
                                    if(element>0){
                                        self.plateConfigOption1 = 1;
                                        self.plateConfig1 = parseInt(element);
                                    }
                                }
                            }
                            break;
                        case 3:
                            //阶段
                            self.emblemStage = parseInt(element);

                            if (self.optionValue == '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }else if(self.optionValue === '17'){
                                self.plateWeight = parseInt(element);
                            }
                            break;
                        case 4:
                            //品质
                            self.emblemQuality = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }else if(self.optionValue === '17'){
                                self.plateSkillNum = parseInt(element);
                            }
                            break;
                        case 5:
                            //宿命
                            let fateArray = element.split("#");
                            self.emblemFate = 3;
                            if(fateArray.length>1){
                                for (let i = 0; i < fateArray.length; i++) {
                                    const element = fateArray[i];
                                    let item = fateArray.splice("@");
                                    self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                                }
                            }else{
                                if(element>0){
                                    self.emblemFate = 2;
                                    self.emblemFateProperty = parseInt(element);
                                }else{
                                    self.emblemFate = 0;
                                }
                            }

                            if (self.optionValue == '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }

                            break;
                        case 6:
                            //宿命自定义概率
                            self.emblemFateCustomize = parseInt(element*100);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }else if(self.optionValue === '17'){
                                let skillArray = element.split("#");
                                if(skillArray.length>=1 && skillArray[0].split("@").length>1){
                                    self.plateConfigOption2 = 2;
                                    for (let i = 0; i < skillArray.length; i++) {
                                        let item = skillArray[i].split("@");
                                        for(let j=0;j<self.plateConfigs.length;j++){
                                            if(self.plateConfigs[j].id===parseInt(item[0])){
                                                self.plateCustomizeTags2[i] = {id:item[0],chance:item[1],data:self.plateConfigs[j]}
                                            }
                                        }
                                    }

                                }else{
                                    if(element>0){
                                        self.plateConfigOption2 = 1;
                                        self.plateConfig2 = parseInt(element);
                                    }
                                }
                            }
                            break;
                        case 7:
                            //主属性
                            self.emblemMainProperty = parseInt(element);
                            break;
                        case 8:
                            //词条属性
                            let entryArray = element.split("#");
                            for (let index = 0; index < entryArray.length; index++) {
                                const entryItem = entryArray[index];
                                let current = self.editEmblemEntries[index];

                                self.emblemEntryConfigs.forEach(item => {
                                    item.children.forEach(iitem => {
                                        if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                            self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                            self.editEmblemEntries[index].active = true;
                                        } else {
                                            self.editEmblemEntries[index].active = false;
                                        }
                                    })
                                })

                                self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                            }

                            let countAndEntry = entryArray[entryArray.length-1].split('|');
                            if (countAndEntry.length>1) {
                                self.rateSwitch = true;
                                self.rate = countAndEntry[1];
                            } else {
                                self.rateSwitch = false;
                            }
                            break;
                        default:
                            break;
                    }
                }
            },

            getIdCn(optionValue,id){
                let self = this;
                if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" || optionValue == "10" || optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" || optionValue == "15"){
                    //道具
                    return self.$t('propConfigName_'+id);
                }else if(optionValue == "1"){
                    //怪兽
                    return self.$t('monsterName_' + id);
                }else if(optionValue == "2"){
                    //怪兽碎片
                    return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
                }else if(optionValue == "6"){
                    //怪兽觉醒水晶
                    return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
                }else if(optionValue == "8"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
                }else if(optionValue == "7"){
                    //战纹
                    return self.$t('warGrooveConfigName_' + id);
                }
            },

            onEditorChange({ quill, html, text },key) {
                var data = quill.editor.delta.ops;
                var jsonData = [];
                data.forEach(item => {
                    if (item.attributes!==undefined && item.attributes.link!==undefined) {
                        jsonData.push({
                            string: item.insert,
                            face: {
                                color: (item.attributes!==undefined && item.attributes.color!==undefined)?item.attributes.color:'#ffffff',
                                dilate: (item.attributes!==undefined && item.attributes.bold!==undefined)?'0.55':'0.52',
                                softness: '0.07'
                            },
                            hyperlink: item.attributes.link,
                            u: (item.attributes!==undefined && item.attributes.underline!==undefined)?item.attributes.underline:false
                        })
                    } else {
                        jsonData.push({
                            string: item.insert,
                            face: {
                                color: (item.attributes!==undefined && item.attributes.color!==undefined)?item.attributes.color:'#ffffff',
                                dilate: (item.attributes!==undefined && item.attributes.bold!==undefined)?'0.55':'0.52',
                                softness: '0.07'
                            },
                            u: (item.attributes!==undefined && item.attributes.underline!==undefined)?item.attributes.underline:false
                        })
                    }
                })
                // this.mailContentObj[key].content = JSON.stringify(jsonData);
                this.mailContentObj[key].content = jsonData;
                this.mailContentObj[key].contentHtml = html;
            }
        },
        components: {
            CommonEditor
        }
    }
</script>

<style scoped>
    .confirm-btn {
        text-align: center;
        margin-top: 50px;
    }

    .el-card {
        margin: 5px 0 !important;
    }

    .mail-badge {
        position: fixed;
        bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/mail_editor.vue